import { render } from "./EntryFlowStatsTable.vue?vue&type=template&id=0067a1c1&scoped=true&ts=true&lang=pug"
import script from "./EntryFlowStatsTable.vue?vue&type=script&lang=ts"
export * from "./EntryFlowStatsTable.vue?vue&type=script&lang=ts"

import "./EntryFlowStatsTable.vue?vue&type=style&index=0&id=0067a1c1&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0067a1c1"]])

export default __exports__